// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XHh0","content":"styles_content__6ai0y","row":"styles_row__2F0zt","footer":"styles_footer__2mZBq","phraseLength":"styles_phraseLength__3cFYG"};